










import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Option } from '@/domains/option';

@Component({ name: 'RecordStatusCheckbox' })
export default class RecordStatusCheckbox extends Vue {
  /** 表单项名 */
  @Prop({ default: '听课档案状态' })
  public label: string;

  /** 禁用 */
  @Prop({ default: (): number[] => [] })
  public disableds: number[];

  /** 表单 */
  @Prop()
  public value: number[];

  public options: Option[] = [];

  public labels: string[] = ['待填写档案', '保存待提交', '正式记录', '驳回待修改', '提交待审核'];

  /** 获取值 */
  get currentValue() { return this.value; }

  /** 返回值 */
  set currentValue(value) { this.$emit('input', value); }

  private created() {
    this.labels.forEach((label: string, index: number) => {
      const option: Option = new Option();
      option.key = index + 1;
      option.value = index + 1;
      option.label = label;
      this.options.push(option);
    });
  }
}
